/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract IConstantFlowAgreementV1",
                name: "cfa",
                type: "address",
            },
            {
                internalType: "contract ISuperfluid",
                name: "superfluid",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "createFlow",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class MultiFlowTesterApp__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(cfa, superfluid, overrides) {
        return super.deploy(cfa, superfluid, overrides || {});
    }
    getDeployTransaction(cfa, superfluid, overrides) {
        return super.getDeployTransaction(cfa, superfluid, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
MultiFlowTesterApp__factory.bytecode = _bytecode;
MultiFlowTesterApp__factory.abi = _abi;
//# sourceMappingURL=MultiFlowTesterApp__factory.js.map